const flowRouter = [
    /**
     * 流程管理
     **/
    {
        path: '/flow/model',
        meta: { title: '模型管理' },
        component: () => import('@/views/flow/model'),
        used: true,
    },
    {
        path: '/flow/flow',
        meta: { title: '流程管理' },
        component: () => import('@/views/flow/flow'),
        used: true,
    },
    {
        path: '/flow/backlog',
        meta: { title: '运行中流程' },
        component: () => import('@/views/flow/backlog'),
        used: true,
    },
    {
        path: '/flow/already',
        meta: { title: '历史的流程' },
        component: () => import('@/views/flow/already'),
        used: true,
    },
    /**
     * 任务管理
     **/
    {
        path: '/task/runTask',
        meta: { title: '待办任务' },
        component: () => import('@/views/flow/task/runTask'),
        used: true,
    },
    {
        path: '/task/doneTask',
        meta: { title: '已办任务' },
        component: () => import('@/views/flow/task/doneTask'),
        used: true,
    },
]

export default flowRouter
